import { formatSigFig } from './formatSigFig'

export const formatLift = (lift: number) => formatSigFig(lift, 2)
